import React from 'react';
import PropTypes from 'prop-types';
import Label from '../../shared/Label';
import * as status from '../../../constants';
import { MatchContainer, MatchResult } from './styles';

const isLive = matchStatus => (matchStatus === status.LIVE_STATUS);

const SingleMatchResult = ({
  awayScore, homeScore, statusTiming,
}) => (
  <MatchContainer>
    <MatchResult>
      <Label
        label={homeScore}
        size={1.8}
        color={isLive(statusTiming) ? 'liveColor' : 'black'}
        isTitleNarrowMedium
        margin="0px 16px"
      />
      <Label
        label={awayScore}
        size={1.8}
        color={isLive(statusTiming) ? 'liveColor' : 'black'}
        isTitleNarrowMedium
        margin="0px 16px"
      />
    </MatchResult>
  </MatchContainer>
);

SingleMatchResult.propTypes = {
  awayScore: PropTypes.any,
  homeScore: PropTypes.any,
  statusTiming: PropTypes.any,
};

export default SingleMatchResult;



// WEBPACK FOOTER //
// ./src/components/shared/SingleMatchResult/index.js